export const round2Decimal = (num: number) => Math.round((num + Number.EPSILON) * 100) / 100

export const roundToNumeric = (num = 0, fraction = 2) => Number(num.toFixed(fraction))

export const formatNumberWithSpaces = (num = 0) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(/\./g, ",");